








import { Component, Vue, Watch } from "vue-property-decorator";
import Axios from "axios";
import RestaurantModule from "@/store/restaurant";
import { asyncForEach } from "@/utils/Util";

@Component
export default class MapViewer extends Vue {
  private get restaurant() {
    return RestaurantModule.restaurant;
  }

  private center = { lat: 38.434332, lng: 141.302868 };

  private zoom = 16;

  private markers: { position: { lat: string; lng: string } }[] = [];

  private mounted() {
    this.init();
  }

  @Watch("restaurant")
  private async init() {
    if (!this.restaurant || !this.restaurant.address) {
      return;
    }
    // eslint-disable-next-line prefer-destructuring
    const address = this.restaurant.address;
    const config = {
      params: {
        address: `${address.postalCode} ${this.restaurant.address.prefecture} ${this.restaurant.address.city} ${this.restaurant.address.addressLine1} ${this.restaurant.address.addressLine2}`,
        key: "AIzaSyCga5qsUCHw6RjJCDSImoDZ0iCGVwJ5tGg",
      },
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (this.$refs.mapRef as any).$mapPromise.then(async (map: any) => {
      const res = await Axios.get("https://maps.googleapis.com/maps/api/geocode/json", config);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      asyncForEach(res.data.results, (result: any) => {
        this.markers.push({ position: result.geometry.location });
      });
      map.panTo({
        lat: res.data.results[0].geometry.location.lat,
        lng: res.data.results[0].geometry.location.lng,
      });
    });
  }
}
